// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input_calendar.mid[data-v-5b03d954], .input_calendar.mid input[data-v-5b03d954] {\n    width: 200px;\n}\ndiv.input_error .inp_cal[data-v-5b03d954] {\n  border: 1px solid #f2084f !important;\n}\n", ""]);
// Exports
module.exports = exports;
